// Pure model behind the topbar switcher and its trigger. No React/DOM imports so it is unit-testable
// in node alongside `hooks/organizationGroups.ts`.
export const PRODUCT_LABEL = { nxt: "NXT", liveblog: "Liveblog" };
/**
 * Collapsed-trigger content: the current Organization's name and image when the shell supplies one
 * that matches a listed Organization, otherwise the current tenant name, otherwise the given fallback.
 * The product is returned separately — the header's product logo conveys it visually, the trigger
 * only carries it in its accessible name.
 */
export function resolveTrigger(groups, currentContext, fallback) {
    if (currentContext?.organizationId && currentContext.product) {
        for (const group of groups) {
            const list = currentContext.product === "nxt" ? group.nxtOrgs : group.liveblogOrgs;
            const found = list.find((org) => org.id === currentContext.organizationId);
            if (found)
                return { label: found.name, product: currentContext.product, imageUrl: found.imageUrl };
        }
    }
    if (currentContext?.tenantId) {
        const group = groups.find((g) => g.id === currentContext.tenantId);
        if (group)
            return { label: group.name };
    }
    return { label: currentContext?.tenantName ?? fallback };
}
export function resolveTriggerLabel(groups, currentContext, fallback) {
    return resolveTrigger(groups, currentContext, fallback).label;
}
export function resolveTriggerAriaLabel(groups, currentContext, fallback) {
    const { label, product } = resolveTrigger(groups, currentContext, fallback);
    return product ? `${label} · ${PRODUCT_LABEL[product]}` : label;
}
export function isCurrent(currentContext, product, orgId) {
    return currentContext?.product === product && currentContext.organizationId === orgId;
}
/** The caller's only reachable Organization, or null when there are none or several. */
export function findSingleOrganization(groups) {
    let found = null;
    let count = 0;
    for (const group of groups) {
        for (const org of group.nxtOrgs) {
            count++;
            found = { group, product: "nxt", name: org.name, imageUrl: org.imageUrl };
        }
        for (const org of group.liveblogOrgs) {
            count++;
            found = { group, product: "liveblog", name: org.name, imageUrl: org.imageUrl };
        }
        if (count > 1)
            return null;
    }
    return count === 1 ? found : null;
}
//# sourceMappingURL=switcherModel.js.map